import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-MailShape",
  "use": "svg-icon-MailShape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-MailShape\"><path d=\"M21.2 3H2.8C1.2 3 0 4.2 0 5.8v12.5C0 19.8 1.2 21 2.8 21h18.5c1.5 0 2.8-1.2 2.8-2.8V5.8C24 4.2 22.8 3 21.2 3zm0 1.5c.3 0 .6.1.8.3l-10 7.3L2 4.8c.2-.2.5-.3.8-.3h18.4zm0 15H2.8c-.7 0-1.2-.6-1.2-1.2v-12L12 13.9l10.5-7.6v12c0 .6-.6 1.2-1.3 1.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol